import type { AccessibilitySettings } from './types'

export function applySettingsToElement(
  el: HTMLElement | null,
  settings: AccessibilitySettings,
): void {
  if (!el) return
  el.dataset.a11yFontSize = settings.fontSize
  el.dataset.a11yFontFamily = settings.fontFamily
  el.dataset.a11yLetterSpacing = settings.letterSpacing
  el.dataset.a11yWordSpacing = settings.wordSpacing
  el.dataset.a11yLineHeight = settings.lineHeight
  el.dataset.a11yContrast = settings.contrastMode
  el.dataset.a11yReducedMotion = String(settings.reducedMotion)
  el.dataset.a11yCvd = settings.colorBlindFilter
  el.dataset.a11yEnhancedFocus = String(settings.enhancedFocus)
  el.dataset.a11yTtsKaraoke = String(settings.ttsKaraoke)
  el.dataset.a11yDistractionFree = String(settings.distractionFree)
}
